// extracted by mini-css-extract-plugin
module.exports = {"firstAnswer":"styles_firstAnswer__22OPB","secondAnswer":"styles_secondAnswer__28-MU","items":"styles_items__2G4LL","item":"styles_item__3KtXA"};